import { render, staticRenderFns } from "./ConservacaoSelect.vue?vue&type=template&id=2bd95456&"
import script from "./ConservacaoSelect.vue?vue&type=script&lang=js&"
export * from "./ConservacaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports